import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "..";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const postEquipment = data => {
  return dispatch => {
    dispatch({ type: "POST_EQUIPMENT_LOADING" });
    api
      .equipmentPost(data)
      .then(resp => {
        if (data.id) {
          dispatch(postEditSucceeded(resp.data));
        } else {
          dispatch(postNewSucceeded(resp.data));
        }
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFailed());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "PostEquipmentErrorAlertTitle",
          "Virhe välineistön tai käyttöoikeuden tallennuksessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const postNewSucceeded = data => ({
  type: "POST_EQUIPMENT_SUCCEEDED",
  payload: { equipment: data },
});

const postEditSucceeded = data => ({
  type: "POST_EQUIPMENT_EDIT_SUCCEEDED",
  payload: { equipment: data },
});

const operationFailed = () => ({
  type: "POST_EQUIPMENT_FAIL",
});
